import { shelfKeys } from './types/shelf-keys';

export const AppConstants = {
    durationForEpisodeEndScreen: 20, // 20 seconds
    durationForTooltipeMessageProgramEnded: 10, // 10 seconds
    EpisodesInLine: 20,
    ItemsInLine: 10,
    GuideTileItemsInLine: 20,
    TotalItems: 1000,
    HomeItemsInLine: 10,
    PlayerItemsInLine: 10,
    HomeRenewInterval: 3600000, // 1h in milliseconds
    HomeUpdateInterval: 60000, // 60c in milliseconds
    VodLineHeight: 470,
    ProgramLineHeight: 366,
    ProgramCardImageWidth: 408,
    ApiMessagesRequestIntervalMS: 18e5, //  30m in ms
    HeaderImageWidth: 1255,
    SkeletonCardLength: 6,
    GenreItemsInLine: 10,
    VodCounterLines: 3,
    SearchCounterLines: 5,
    HomeCounterLines: 3,
    DetailCounterLines: 3,
    MostPopularItemsInLine: 10,
    loadingUrl: `/images/publisher/loading.svg`,
    loadingUrlGray: `/images/gray/loading.svg`,
    loadingPreviewUrl: `/images/publisher/loading-preview.svg`,
    sizeHalfHourPx: 424,
    quantityOfMsInOneDay: 24 * 60 * 60 * 1000,
    shelfKeys: shelfKeys,
    programImageWidth: 408,
    defaultSkipTime: 15, // 15 seconds
    keyCacheBrowser: 'CACHE_VERSION',
    searchStringDemo: 'demo'
} as const;